import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ displayState }) => css`
    background-color: ${displayState?.color ? `${displayState?.color}1A` : `${window?.settings?.primary_color ?? '#1DBD6B'}1A`};
    font-size: 12px;
    padding: ${displayState?.padding ?? '4px 12px'};
    color:${displayState?.color ?? window?.settings?.primary_color ?? '#1DBD6B'};
    border-radius: 60px;
  `}
`;


export default Atom({ type: 'label', dataType: 'string', template })